import { BackButton as LegacyBackButton } from "@/components/Funnel/BackButton";

export function BackButton({ className }: { className?: string }) {
  return (
    <div className={className}>
      <LegacyBackButton />
    </div>
  );
}
